import { lazy } from "react";
import SupportRoutes from "../container/Support";
import FinancialRoutes from "../container/Financial";
import SpeedTestRoutes from "../container/SpeedTest";
import HelpRoutes from "../container/Help";
import NoMatch from "../container/NoMatch";
import Icon from "../components/Icon";
import { RouteType } from "ui-modules/components/Navigation/Routes/CreateRoutes";

const Dashboard = lazy(() => import("../container/Dashboard"));
const Services = lazy(() => import("../container/Services"));
const Notifications = lazy(() => import("../container/Notifications"));
const ServiceDetail = lazy(() => import("../container/ServiceDetail"));
const ServiceRenew = lazy(() => import("../container/ServiceRenew"));
const Profile = lazy(() => import("../container/Profile"));
const ChangePassword = lazy(() => import("../container/ChangePassword"));
const ExportFile = lazy(() => import("../container/ExportFile"));
const CustomerUsage = lazy(() => import("../container/CustomerUsage"));
const ServiceUpgradePromotion = lazy(() => import("../container/ServiceUpgradePromotion"));
// const Introduction = lazy(() => import("../container/Introduction"));

let customerRoutes: RouteType[] = [
  {
    path: "/",
    exact: true,
    title: "خانه",
    sidebar: true,
    iconTag: <Icon name={"home"} className={"drawerIcons large"} />,
    component: Dashboard,
    className: "sidebar-menu-home",
    roles: ["GLOBAL"],
  },
  {
    path: "/services",
    exact: true,
    title: "سرویس‌های من",
    sidebar: true,
    iconTag: <Icon name={"services"} className={"drawerIcons large"} />,
    component: Services,
    className: "sidebar-menu-services",
    roles: ["GLOBAL"],
  },
  {
    path: "/services/service-detail/:id",
    exact: true,
    component: ServiceDetail,
    roles: ["GLOBAL"],
  },
  {
    path: "/services/service-renew/:dealID?/:agreementID?/:defaultInterval?",
    exact: true,
    component: ServiceRenew,
    roles: ["GLOBAL"],
  },
  {
    path: "/services/service-upgrade-promotion/:dealID/:agreementID",
    exact: true,
    component: ServiceUpgradePromotion,
    roles: ["GLOBAL"],
  },
  {
    path: "/notifications",
    exact: true,
    title: "اعلان‌های دریافتی",
    sidebar: true,
    iconTag: <Icon name={"bell"} className={"drawerIcons large"} />,
    component: Notifications,
    className: "sidebar-menu-notifications",
    roles: ["GLOBAL"],
  },
  {
    path: "/support",
    exact: true,
    title: "پشتیبانی",
    sidebar: true,
    iconTag: <Icon name={"headset"} className={"drawerIcons large"} />,
    routes: SupportRoutes,
    className: "sidebar-menu-support",
    roles: ["GLOBAL"],
  },
  {
    path: "/financial",
    exact: true,
    title: "مالی",
    sidebar: true,
    iconTag: <Icon name={"financial-chart"} className={"drawerIcons large"} />,
    routes: FinancialRoutes,
    className: "sidebar-menu-financial",
    roles: ["GLOBAL"],
  },
  {
    path: "/speed-test",
    exact: true,
    title: "تست سرعت",
    sidebar: true,
    iconTag: <Icon name={"timer-speed"} className={"drawerIcons large"} />,
    routes: SpeedTestRoutes,
    className: "sidebar-menu-speedTest",
    roles: ["LIMITED"],
  },
  {
    path: "/help",
    exact: true,
    title: "راهنما",
    sidebar: true,
    iconTag: <Icon name={"thinking"} className={"drawerIcons large"} />,
    routes: HelpRoutes,
    className: "sidebar-menu-help",
    roles: ["LIMITED"],
  },
  {
    path: "/profile",
    exact: true,
    component: Profile,
    roles: ["GLOBAL"],
  },
  {
    path: "/change-password",
    exact: true,
    component: ChangePassword,
    roles: ["GLOBAL"],
  },
  {
    path: "/export-file/:id/:type",
    exact: true,
    component: ExportFile,
    roles: ["LIMITED"],
  },
  // {
  //   path: "/introduction",
  //   exact: true,
  //   component: Introduction,
  // },
  {
    path: "/services/customer-usage/:id",
    exact: true,
    component: CustomerUsage,
    roles: ["GLOBAL"],
  },
  {
    path: "*",
    exact: false,
    component: NoMatch,
  },
];

export default customerRoutes;
